import { render } from "./UiLayer.vue?vue&type=template&id=377d566a"
import script from "./UiLayer.vue?vue&type=script&lang=js"
export * from "./UiLayer.vue?vue&type=script&lang=js"

import "./UiLayer.vue?vue&type=style&index=0&id=377d566a&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__